<template>
  <div class="container">
    <wrap-container class="w100 container-bonus">
      <ul class="awardsList">
        <li v-for="pack in orderBy(packagesShow)" :key="pack.id">
          <span class="circle"
            ><img
              v-bind:src="require('../../assets/img/1x/' + pack.url)"
              alt="Paquete"
          /></span>
          <p class="bonus-title" v-safe-html="pack.titleAward" />
          <p class="bonus-description" v-safe-html="pack.detailsAward" />
        </li>
      </ul>
      <br />
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import AdwardsConfig from "@/config/constants/packageAwards";
import { packageCode } from "@/config/constants/packagesCodes";
export default {
  name: "AppFooter",
  props: {
    idPackage: {
      type: String,
      default: null,
      required: false
    }
  },
  components: {
    WrapContainer
  },
  data() {
    return {
      packagesShow: []
    };
  },
  mounted() {
    if (this.idPackage) {
      switch (this.idPackage) {
        case packageCode.LIBRETON_EXPRESS:
          this.addListAwards(
            AdwardsConfig.libreton_express.LatamPass,
            AdwardsConfig.libreton_express.creditCard,
            AdwardsConfig.libreton_express.bonusPack,
            AdwardsConfig.libreton_express.loansExclusive
          );
          break;
        case packageCode.LIBRETON_FULL:
          this.addListAwards(
            AdwardsConfig.libreton_full.LatamPass,
            AdwardsConfig.libreton_full.creditCard,
            AdwardsConfig.libreton_full.bonusPack,
            AdwardsConfig.libreton_full.loansExclusive
          );
          break;
        case packageCode.LIBRETON_PLUS_GOLD:
          this.addListAwards(
            AdwardsConfig.libreton_plus_gold.LatamPass,
            AdwardsConfig.libreton_plus_gold.creditCard,
            AdwardsConfig.libreton_plus_gold.bonusPack,
            AdwardsConfig.libreton_plus_gold.loansExclusive
          );
          break;
        case packageCode.LIBRETON_PREMIUM:
          this.addListAwards(
            AdwardsConfig.libreton_premium.LatamPass,
            AdwardsConfig.libreton_premium.creditCard,
            AdwardsConfig.libreton_premium.bonusPack,
            AdwardsConfig.libreton_premium.loansExclusive
          );
          break;
        case packageCode.LIBRETON_PREMIUM_WORLD:
          this.addListAwards(
            AdwardsConfig.libreton_premium_world.LatamPass,
            AdwardsConfig.libreton_premium_world.creditCard,
            AdwardsConfig.libreton_premium_world.bonusPack,
            AdwardsConfig.libreton_premium_world.loansExclusive
          );
          break;
      }
    } else {
      this.addListAwards(
        AdwardsConfig.default.LatamPass,
        AdwardsConfig.default.creditCard,
        AdwardsConfig.default.bonusPack,
        AdwardsConfig.default.loansExclusive
      );
    }
  },
  computed: {},
  methods: {
    orderBy: function(arr) {
      return arr.slice().sort(function(a, b) {
        return a.id - b.id;
      });
    },
    addListAwards: function(bonusA, BonusB, BonusC, BonusD) {
      this.packagesShow.push(bonusA, BonusB, BonusC, BonusD);
    }
  }
};
</script>

<style scoped>
.circle {
  width: 120px;
  height: 120px;
  background-color: #f4f4f4;
  display: flex;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -khtml-border-radius: 50%;
  vertical-align: top;
  text-align: center;
}

.circle img {
  vertical-align: middle;
}

.container-bonus {
  margin: 60px 0 70px 0;
}

.awardsList {
  padding: 0;
  list-style: none;
  text-align: left;
  display: block;
}

.awardsList li {
  vertical-align: top;
  float: left;
  width: 261px;
  margin-right: 30px;
}

.bonus-title {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 16px;
  color: #121212;
}

.bonus-description {
  font-size: 15px;
  line-height: 1.6;
}

br {
  clear: left;
}

@media screen and (max-width: 624px) {
  .awardsList li {
    padding: 20px;
    margin-right: 0;
    width: auto;
    float: none !important;
    display: block !important;
  }
}

@media screen and (max-width: 624px) {
  .container-bonus {
    margin: 20px 0 20px 0;
  }

  .awardsList li {
    margin-bottom: 14px;
    -webkit-box-shadow: 2px 1px 7px -3px rgba(0, 0, 0, 0.53);
    -moz-box-shadow: 2px 1px 7px -3px rgba(0, 0, 0, 0.53);
    box-shadow: 2px 1px 7px -3px rgba(0, 0, 0, 0.53);
  }
  .circle {
    display: none;
  }
  .bonus-title,
  .bonus-description {
    font-size: 15px;
  }

  .bonus-title {
    margin: 0 0 0 0 !important;
  }

  .bonus-description {
    margin: 0 0 0 0 !important;
  }
}
</style>
